import script from "./ToolbarComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToolbarComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ToolbarComponent.vue?vue&type=style&index=0&id=274e45af&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-274e45af"]])

export default __exports__